import { TableSchema } from '../metadata-schema';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { Niveau } from '../enums/Niveau';
import { Vaardigheid } from '../enums/Vaardigheid';

export const fac_bv_basisvaardigheden: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_bv_basisvaardigheden",
	"description": "Definitie voor fact tabel fac_bv_basisvaardigheden uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"bv_d_afname": {
			"type": "string",
			"format": "date",
			"label": "Datum afname",
			"category": "Basisvaardigheden",
			"example": "14-09-2023",
			"description": "Datum waarop deze basisvaardighedentoets is afgenomen."
		},
		"bv_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"bv_fk_ilt_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"bv_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"bv_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"bv_fk_lb": {
			"exclude": [
				"lb_d_examen",
				"lb_is_examenkandidaat",
				"lb_is_examenopleiding",
				"lb_nm_examenstatus",
				"lb_nm_idu",
				"lb_nm_leerfase",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"bv_fk_lb_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"bv_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"bv_fk_ll": {
			"exclude": [
				"ll_is_cohortstatus_tot_volledig"
			],
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"bv_fk_vs": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"bv_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 april van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 april wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 augustus van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 augustus wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 december van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 december wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 februari van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 februari wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 januari van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 januari wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 juli van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 juli wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 juni van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 juni wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 mei van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 mei wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 maart van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 maart wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 november van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 november wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 oktober van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 oktober wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de actuele leerlingplaatsing ten tijde van de afnamedatum van \ndeze basisvaardighedentoets, ook actief was op 1 september van het betreffende \nschooljaar. Indien Nee, kan het zijn dat de leerling op 1 september wel een \nandere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"bv_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"bv_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ...",
			"description-magister": "De eerste of tweede nationaliteit van deze leerling.",
			"description-somtoday": "De eerste of tweede nationaliteit van deze leerling.\nIndien in Somtoday de nationaliteit volgens het BRP is ingevuld, wordt dit \nveld gebruikt, tenzij het vinkje \"wijkt bewust af\" is ingeschakeld."
		},
		"bv_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"bv_fun_nr_referentieniveau_bin": {
			"type": "number",
			"label": "Referentieniveau (score)",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bv_fun_sortkey_afname": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bv_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"bv_is_eindtoets_po": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of deze basisvaardighedentoets een PO-doorstroomtoets is."
		},
		"bv_nm_aanbieder": {
			"type": "string",
			"label": "Toetsaanbieder",
			"category": "Basisvaardigheden",
			"searchKeys": [
				"CITO",
				"JIJ",
				"DIA"
			],
			"example": "CITO, JIJ, DIA",
			"description": "De aanbieder van deze basisvaardighedentoets, zoals CITO, DIA of JIJ (Bureau ICE). Voor de doorstroomtoets op de basisschool kan dit ook één van de aanbieders van PO-doorstroomtoetsen zijn."
		},
		"bv_nm_leerfase": {
			"type": "string",
			"label": "Leerfase",
			"category": "Opleiding",
			"example": "HAVO 3, VMBO b/k 1, OND 2",
			"description": "De combinatie van niveau en leerjaar van de leerling ten tijde van de afnamedatum van deze basisvaardighedentoets. Niet gevuld voor PO-doorstroomtoetsen."
		},
		"bv_nm_referentieniveau": {
			"type": "string",
			"label": "Referentieniveau",
			"category": "Basisvaardigheden",
			"example": "1F, 2F, >=3F, Op weg naar 3F, ...",
			"description": "Het behaalde referentieniveau dat deze leerling heeft behaald voor deze basisvaardighedentoets.\nDit veld bevat de tekst zoals door de toetsaanbieder aangeleverd, dus dit veld kan naast \"1F\" t/m \"4F\" ook waarden bevatten als \"Op weg naar 2F\" of \"Lager dan 1F\"."
		},
		"bv_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Basisvaardigheden",
			"filter": false,
			"grouping": false,
			"example": "2022/2023",
			"description": "Het schooljaar op de afnamedatum van deze basisvaardighedentoets."
		},
		"bv_nm_toets": {
			"type": "string",
			"label": "Toetsnaam",
			"category": "Basisvaardigheden",
			"example": "Toets 0 CITO Volgsysteem VO HV, Diatekst versie A, Nederlands Lezen 3F - 1, ...",
			"description": "De originele naam van deze basisvaardighedentoets."
		},
		"bv_nm_toetsmoment": {
			"type": "string",
			"label": "Toetsmoment",
			"category": "Basisvaardigheden",
			"example": "T0, T1, ...",
			"description": "\"T\" gevolgd door het leerjaar van de leerling ten tijde van de afnamedatum van deze basisvaardighedentoets. In leerjaar 1 hebben toetsen afgenomen in augustus t/m december toetsmoment \"T0\". PO-doorstroomtoetsen hebben toetsmoment \"PO\"."
		},
		"bv_nm_toetsniveau": {
			"label": "Toetsniveau",
			"category": "Basisvaardigheden",
			"example": "VMBO b, HAVO, ...",
			"description": "Het VO-niveau van de doelgroep voor deze basisvaardighedentoets, zoals opgegeven door de toetsaanbieder. Dit veld is niet altijd gevuld.",
			"type": "string",
			"schema": Niveau
		},
		"bv_nm_vaardigheid": {
			"label": "Basisvaardigheid",
			"category": "Basisvaardigheden",
			"searchKeys": [
				"Leesvaardigheid",
				"Taalverzorging",
				"Rekenen"
			],
			"example": "Leesvaardigheid, Taalverzorging, Rekenen",
			"description": "De vaardigheid (Leesvaardigheid, Taalverzorging of Rekenen) die deze basisvaardighedentoets toetst. Toetsen waarbij in meerdere onderdelen verschillende vaardigheden worden getoetst, zoals de PO-doorstroomtoets en basisvaardighedentoetsen van CITO, zijn in CumLaude opgeslagen als afzonderlijke toetsen met dezelfde naam.",
			"type": "string",
			"schema": Vaardigheid
		},
		"bv_nr_leerjaar": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar",
			"category": "Opleiding",
			"example": "1, 2, 3, 4, 5, 6",
			"description": "Het leerjaar (1 t/m 6) van de leerling ten tijde van de afnamedatum van deze basisvaardighedentoets. Niet gevuld voor PO-doorstroomtoetsen."
		},
		"bv_nr_leerling": {
			"type": "integer",
			"label": "Leerlingnummer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het leerlingnummer van de leerling."
		},
		"bv_nr_referentieniveau": {
			"type": "number",
			"label": "Referentieniveau (numeriek)",
			"category": "Basisvaardigheden",
			"example": "0, 1, 2, 3, 4",
			"description": "De numerieke waarde van het behaalde referentieniveau. Dit wordt als volgt bepaald:\n- De fundamentele niveaus 1F t/m 4F hebben 1 t/m 4 als numerieke waarde. \"0F\" wordt 0.\n- Streefniveau 1S dat incidenteel voorkomt bij PO-doorstroomtoetsen hebben 1 als numerieke waarde.\n- \"Tussen-niveaus\" zoals \"Op weg naar 2F\", \"lager dan 2F\", \">2F\" hebben een numerieke waarde van een half niveau lager of hoger dan het genoemde referentieniveau. Hoewel dergelijke niveaus aangeven dat de leerling het betreffende niveau nog niet heeft gehaald of juist beter scoort dan de toets kan meten, krijgt men met dit halve punt toch enig inzicht in eventueel gemaakte voortgang."
		},
		"bv_nr_verbetering": {
			"type": "number",
			"label": "Verbetering t.o.v. vorig toetsmoment",
			"category": "Basisvaardigheden",
			"example": "0, 1, 2, -1, ...",
			"description": "De numerieke verbetering ten opzicht van het vorige toetsmoment. Dit wordt bepaald door de numerieke waarde van het referentieniveau van de laatste basisvaardighedentoets van het vorige toetsmoment voor dezelfde vaardigheid af te trekken van de numerieke waarde die behaald is voor deze toets. Voor toetsmoment T0 wordt geen verschil bepaald, ook niet ten opzichte van de PO-doorstroomtoets, omdat dit geen betrouwbare vergelijking geeft. Het vorige toetsmoment kan meer dan 1 leerjaar geleden zijn als er vorig jaar niet getoetst is."
		},
		"bv_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
